import { Validator } from '@portal/kit/pkg/services'

const userPasswordValidator = (user, values) => {
  const rules = {
    phone_number: ['isRequired', 'isPhoneNumber', ['isExludedFrom', { values: [user.phone_number] }]]
  }

  if (typeof values.phone_number === 'string') {
    values.phone_number = values.phone_number.replace(/\s/g, '')
  }

  return new Validator(values, rules).getErrors()
}

export default userPasswordValidator
